var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_menu)?_c('div',[(_vm.isBelowMd)?_c('nav',[_c('NavMobile',{attrs:{"from-ca":true}})],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }